<template>
  <v-navigation-drawer
    app
    clipped
    disable-resize-watcher
    color="grey darken-3"
    v-model="visible"
    @input="onInput"
    temporary
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title" style="color: white;">
          SOE Dashboard
        </v-list-item-title>
        <v-list-item-subtitle style="color: white;">
          choose a view
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense nav>

      <v-list-item link to="/">
        <v-list-item-icon>
          <v-icon style="color: white;">dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="Aligners">
        <v-list-item-icon>
          <v-icon style="color: white;">control_camera</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Equipment</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="Radar">
        <v-list-item-icon>
          <v-icon style="color: white;">track_changes</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">My Radar</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="SupportTickets">
        <v-list-item-icon>
          <v-icon style="color: white;">bug_report</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Support Tickets</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--
      <v-list-item v-if="canShowAudits" link to="Audits">
        <v-list-item-icon>
          <v-icon style="color: white;">assignment</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Audits</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      -->

      <v-list-item link to="CameraCal">
        <v-list-item-icon>
          <v-icon style="color: white;">cameraswitch</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Camera Cal</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="SoftwareUpdates">
        <v-list-item-icon>
          <v-icon style="color: white;">backup</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Software Updates</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="SpecUpdates">
        <v-list-item-icon>
          <v-icon style="color: white;">cloud_circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Spec Updates</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="canShowUpdateScheduler" link to="UpdateScheduler">
        <v-list-item-icon>
          <v-icon style="color: white;">assignment</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Update Scheduler</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="TrendChart">
        <v-list-item-icon>
          <v-icon style="color: white;">map</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Trend Chart</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="canShowEasy" link to="Easy">
        <v-list-item-icon>
          <v-icon style="color: white;">my_location</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">EZ ADAS</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="canShowNotifications" link to="Notifications">
        <v-list-item-icon>
          <v-icon style="color: white;">input</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Notifications / Ads</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--
      <v-list-item v-if="canShowMessaging" link to="Messaging">
        <v-list-item-icon>
          <v-icon style="color: white;">email</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Messaging</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      -->

      <v-list-item v-if="canShowTruPoint" link to="TruPoint">
        <v-list-item-icon>
          <v-icon style="color: white;">navigation</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">TruPoint</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="AIKnow">
        <v-list-item-icon>
          <v-icon style="color: white;">question_answer</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">AIKnow</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="canShowUsers" link to="Users">
        <v-list-item-icon>
          <v-icon style="color: white;">people</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Users</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--
      <v-list-item @click.stop="onDemoClicked">
        <v-list-item-icon>
          <v-icon style="color: white;">drive_eta</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white;">Aligner Demo</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    canShowAudits() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
        )
      );
    },

    canShowEasy() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
          || this.$store.state.auth.token.user.role === 'ezadas'
          || this.$store.state.auth.token.user.role === 'support_lvl2'
        )
      );
    },

    canShowNotifications() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
        )
      );
    },

    canShowMessaging() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
        )
      );
    },

    canShowUpdateScheduler() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
          || this.$store.state.auth.token.user.role === 'support_lvl2'
        )
      );
    },

    canShowTruPoint() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
          || this.$store.state.auth.token.user.role === 'support_lvl2'
          || this.$store.state.auth.token.user.role === 'support'
        )
      );
    },

    canShowUsers() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
        )
      );
    },

    canShowMaps() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
        )
      );
    },
  },

  methods: {
    onInput(value) {
      if (value === false) {
        this.$emit('closed');
      }
    },

    onDemoClicked() {
      const options = {
        method: 'GET',
        url: '/read/demo_port/v1',
      };

      this.axios(options)
        .then((res) => {
          window.open(`http://vehicle365.org:${res.data.port}`, '_blank');
        });
      //        .catch(() => {
      // console.error('!!! failed response !!!');
      //        });
    },
  },
};
</script>

<style scoped>

</style>
